// test2574
(2574 && 0);
